import React from 'react';

const FAQ = () => (
    <div style={{width: '90vw', margin: '0 auto'}}>
        <h1 style={{color: '#dfae20', fontFamily: 'fantasy', fontSize: '50px'}}>FAQ</h1>
        <h3 style={{color: '#dfae20', lineHeight: '1.5em'}}>How does a sniper bot work?</h3>
        <h4 style={{color: '#dfae20', lineHeight: '1.5em', fontWeight: '250'}}>Sniper bots work by utilizing RPC's which
            are endpoints that connect directly to blockchain using the router provided (PCS, Uniswap, Sol, etc..)</h4>
        <h3 style={{color: '#dfae20', lineHeight: '1.5em'}}>Does it work on mobile and desktop?</h3>
        <h4 style={{color: '#dfae20', lineHeight: '1.5em', fontWeight: '250'}}>Most bots by design only work for
            desktop, but with Adam's Sniper Bot, you get the best of both worlds. Compatible with mobile devices and
            desktops.</h4>
        <h3 style={{color: '#dfae20', lineHeight: '1.5em'}}>What is a private key and why do you need it?</h3>
        <h4 style={{color: '#dfae20', lineHeight: '1.5em', fontWeight: '250'}}>Private keys act as signers for your
            transactions.
            You can't execute a transaction without signing it, and a private key or mnemonic phrase is what's used to
            sign
            these transactions. Without them, the bot won't be able to execute transactions on your behalf.</h4>
        <h3 style={{color: '#dfae20', lineHeight: '1.5em'}}>Which cryptowallet do I need?</h3>
        <h4 style={{color: '#dfae20', lineHeight: '1.5em', fontWeight: '250'}}>A Metamask wallet is required for this
            bot.
            You can download it from their official website here: <a style={{color: '#5e8ce8'}}
                                                                     href={"https://metamask.io/"}
                                                                     target={'blank'}>https://metamask.io/</a><br/><br/>
            Make sure to create a new wallet and not to use your main wallet for any bots you purchase in the event a
            security breach occurs.
        </h4>
        <h3 style={{color: '#dfae20', lineHeight: '1.5em'}}>How do I order and pay for the snipebot?</h3>
        <h4 style={{color: '#dfae20', lineHeight: '1.5em', fontWeight: '250'}}>You can click the contact info at the
            bottom of this page to get started using the bot!
        </h4>
        <h3 style={{color: '#dfae20', lineHeight: '1.5em'}}>How do I set-up the snipebot?</h3>
        <h4 style={{color: '#dfae20', lineHeight: '1.5em', fontWeight: '250'}}>Once you've purchased the bot, simply
            enter your private key {`at `}
            <a style={{color: '#5e8ce8'}}
               href={"https://adamsnipes.io"}
               target={'blank'}>{`The Homepage`}</a> In order to get started.
        </h4>
        <h3 style={{color: '#dfae20', lineHeight: '1.5em'}}>Does the bot only buy or also sell the tokens?</h3>
        <h4 style={{color: '#dfae20', lineHeight: '1.5em', fontWeight: '250'}}>The bot can buy and sell your tokens as
            well! That means a faster sniping experience, as well as collecting profits just as fast!
        </h4>
        <h3 style={{color: '#dfae20', lineHeight: '1.5em'}}>What are the future development plans for this bot?</h3>
        <h4 style={{color: '#dfae20', lineHeight: '1.5em', fontWeight: '250'}}>In the near future I plan on adding features to scan new coins that are added for liquidity in order to snipe straight from the bot. As well as a redefined 'wallet' experience, where you'll never need to open another app just to see your assets. Everything will be accessible from the bot!</h4>
        <h3 style={{color: '#dfae20', lineHeight: '1.5em'}}>Sounds Great! Who do I contact for more information or help?</h3>
        <h4 style={{color: '#dfae20', lineHeight: '1.5em', fontWeight: '250'}}>You can contact me using the information below.
        </h4>
    </div>
)

export default FAQ;